export default {
  SERVER_ERROR: 'Server Error',
  SERVER_ERROR_INFO: 'We are working to resolve it',
  INSUFFICIENT_RISK_PROFILE_DATA_EVALUE:
    'Ensure Time Horizon and Recommended Risk Profile fields are complete on the Risk Analysis page',
  INSUFFICIENT_RISK_PROFILE_DATA_MORNINGSTAR:
    'Ensure Time Horizon and Suitability Score fields are complete on the Risk Analysis page'
};
